import { createBrowserRouter } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import RootLayout from '@/layouts/RootLayout'
import NotFoundPage from '@/pages/NotFoundPage'
import LoadingSpinner from '@/components/ui/LoadingSpinner'

const HomePage          = lazy(() => import('@/pages/HomePage'))
const AboutPage         = lazy(() => import('@/pages/AboutPage'))
const HowItWorksPage    = lazy(() => import('@/pages/HowItWorksPage'))
const CategoryPage      = lazy(() => import('@/pages/CategoryPage'))
const LocationPage      = lazy(() => import('@/pages/LocationPage'))
const TestimonialsPage  = lazy(() => import('@/pages/TestimonialsPage'))
const FAQPage           = lazy(() => import('@/pages/FAQPage'))
const ContactPage       = lazy(() => import('@/pages/ContactPage'))

const wrap = (Page: React.ComponentType) => (
  <Suspense fallback={<LoadingSpinner />}>
    <Page />
  </Suspense>
)

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true,                                 element: wrap(HomePage) },
      { path: 'about',                               element: wrap(AboutPage) },
      // Legacy redirect — /about-us → /about handled in nginx
      { path: 'how-it-works',                        element: wrap(HowItWorksPage) },

      // Buying categories — each has its own SEO slug
      { path: 'coins-we-buy',                        element: <Suspense fallback={<LoadingSpinner />}><CategoryPage /></Suspense> },
      { path: 'jewelry-we-buy',                      element: <Suspense fallback={<LoadingSpinner />}><CategoryPage /></Suspense> },
      { path: 'gold-silver-we-buy',                  element: <Suspense fallback={<LoadingSpinner />}><CategoryPage /></Suspense> },
      { path: 'currency-we-buy',                     element: <Suspense fallback={<LoadingSpinner />}><CategoryPage /></Suspense> },
      { path: 'vintage-watches-we-buy',              element: <Suspense fallback={<LoadingSpinner />}><CategoryPage /></Suspense> },
      { path: 'historical-items-we-buy',             element: <Suspense fallback={<LoadingSpinner />}><CategoryPage /></Suspense> },

      // Locations
      { path: 'locations/:id',                       element: wrap(LocationPage) },

      // Supporting pages
      { path: 'testimonials',                        element: wrap(TestimonialsPage) },
      { path: 'faqs',                                element: wrap(FAQPage) },
      { path: 'contact',                             element: wrap(ContactPage) },
    ],
  },
])
